import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import Image from 'next/image'
import { convertTripMetrics, guidGenerator } from '../../utils/functions'
import { IDirectionStep } from '../../types'

interface IStep {
    step: IDirectionStep
    id: string
}

const Step: React.FC<IStep> = ({ step, id }) => {
    const parsedStep = {
        ...step,
        id,
    }
    const parsedStepModifier = step?.maneuver?.modifier?.replace(/ /g, '_')
    const parsedStepType = step?.maneuver?.type?.replace(/ /g, '_')?.replace('exit_', '')
    const iconPath = parsedStepModifier
        ? `/assets/directions-icons/svg/${parsedStepType}_${parsedStepModifier}.svg`
        : `/assets/directions-icons/svg/${parsedStepType}.svg`
    return (
        <div key={`${parsedStep.id}`} className={`flex id-${parsedStep.id}`}>
            <div className='mr-2 flex'>
                <div className='relative h-5 w-5'>
                    <Image
                        src={iconPath}
                        alt={`Icon for ${step?.maneuver?.instruction}`}
                        layout='fill'
                    />
                </div>
            </div>
            <div className='flex flex-col gap-y-1'>
                <p className='text-sm'>{step?.maneuver?.instruction}</p>
                <div className='flex text-xs text-gray-300'>
                    <p>
                        {convertTripMetrics(step)?.distance} - {convertTripMetrics(step)?.totalTime}
                    </p>
                </div>
            </div>
        </div>
    )
}
export default Step
